import { apiBaseUrl } from 'app/src/msw/moneytransfer/api/apiBaseurl'
import { transfersCollection } from 'app/src/msw/moneytransfer/initialSeed/transfers'
import type { moneytransferApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

export const getTransfer = http.get<
  { transferId: string },
  object,
  moneytransferApi.TransferResponseWithUserInfo | moneytransferApi.ErrorModel
>(apiBaseUrl + '/transfers/:transferId', async ({ params }) => {
  const order = transfersCollection.findFirst((q) => q.where({ orderId: params.transferId }))

  await new Promise((resolve) => setTimeout(resolve, 3000))

  if (!order) {
    const responseError: moneytransferApi.ErrorModel = {
      type: 'ErrorEntityNotFound',
      status: 404,
      title: 'Transfer not found',
    }
    return HttpResponse.json(responseError, { status: 404 })
  }

  const transferResponse: moneytransferApi.TransferResponseWithUserInfo = transfersCollection.findFirst((q) =>
    q.where({ id: params.transferId }),
  ) as moneytransferApi.TransferResponseWithUserInfo

  return HttpResponse.json(transferResponse)
})
